<div class="container" [ngClass]="{'ionic': useIonic }">
    <div class="header">
        <shared-address-ambit-selector-component [value]="addressAmbit"
            (changeValues)="onChangeAddressAmbitSelector($event)">
        </shared-address-ambit-selector-component>

        <div class="search-pair">
            <input type="text" class="searchbox" placeholder="{{ 'SEARCH' | translate }}"
                (ngModelChange)="this.searchTextUpdate.next($event)" [(ngModel)]="searchText" />
            <div class="searchbox-contadors">{{ getSelectedRoutesCount() }}</div>
        </div>
        <div class="actions">
            <actions *ngIf="!showingSelectedRoutes" [actionstrip]="actions" (clickAction)="onClickAction($event)">
            </actions>
            <actions *ngIf="showingSelectedRoutes" [actionstrip]="confirmRoutesActions"
                (clickAction)="onClickAction($event)">
            </actions>
        </div>
    </div>

    <div class="divSeccio header">
        <div *ngIf="showingSelectedRoutes" class="explanation" [innerHTML]="('BOOKINGPAGE.CONFIRMPENDING.HELP' |
            translate: { routesCount: selectedRoutes.length }) | safe:'html'"></div>
    </div>

    <ng-container *ngIf="!showingSelectedRoutes">
        <div class="divSeccio">
            <shared-route-item-list
                *ngFor="let item of routes | filterActiveRoutes:searchText:filterMetadata | orderbyroutecarddto:true | slice:0:sliceCount; let i=index"
                [route]="item" (click)="onSelectRoute(item)" class="routeItem monochrome reduced"
                [selected]="selectedRoutes.includes(item.routeId)">
            </shared-route-item-list>

            <button class="slice-button" (click)="onSliceMoreRoutes()"
                *ngIf="sliceCount!=routesCount && sliceCount<filterMetadata.count">
                {{'GENERAL.SLICE.BUTTON' | translate:{ sliceCount: sliceCount, itemsCount:routesCount} }}
            </button>
        </div>
        <div class="bookingSearchRoutesWithBooking-dummy"></div>
        <div *ngIf="bookingSearchRoutesWithBooking != null && bookingSearchRoutesWithBooking.routeCount > 0"
            class="banner-withbooking">
            <div class="icona"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div>
            <div class="texte" [innerHTML]="bookingSearchRoutesWithBooking.message | safe: 'html'">
            </div>
        </div>
    </ng-container>
    <div class="divSeccio" *ngIf="showingSelectedRoutes">
        <shared-route-item-list
            *ngFor="let item of getSelectedRoutes() | filterActiveRoutes:searchText:filterMetadata | orderbyroutecarddto:true; let i=index"
            [route]="item">
        </shared-route-item-list>
    </div>

</div>